import { useMemo } from "react";
import { NeedForSweepDataPoints } from "./NeedForSweepDataPoints";
import { YAxis } from "@mui/x-charts-premium";

export const useYAxis = (
  dataset: NeedForSweepDataPoints,
  sootIndexThreshold: number,
  burnHoursThreshold: number,
  hideAxisLabels: boolean
): Array<YAxis<"linear">> => {
  return useMemo(() => {
    const yAxis: Array<YAxis<"linear">> = [];

    yAxis.push({
      id: "burnHours",
      scaleType: "linear",
      min: 0,
      max: Math.max(
        dataset.max("burnHoursCumulative", burnHoursThreshold),
        dataset.max("predictedBurnHoursCumulative", burnHoursThreshold)
      ),
      width: hideAxisLabels ? 50 : 75,
    } as YAxis<"linear", number>);

    yAxis.push({
      id: "sootIndex",
      scaleType: "linear",
      min: 0,
      max: Math.max(
        dataset.max("sootIndexCumulative", sootIndexThreshold),
        dataset.max("predictedSootIndexCumulative", sootIndexThreshold)
      ),
      width: hideAxisLabels ? 50 : 75,
    } as YAxis<"linear", number>);

    yAxis.push({
      id: "sootingDegree",
      scaleType: "linear",
      min: 0,
      max: Math.max(
        dataset.max("sootingDegreeCumulative", 100),
        dataset.max("predictedSootingDegreeCumulative", 100)
      ),
      valueFormatter: (v) => {
        return `${v} %`;
      },
      width: hideAxisLabels ? 50 : 75,
    } as YAxis<"linear", number>);

    return yAxis;
  }, [burnHoursThreshold, dataset, sootIndexThreshold, hideAxisLabels]);
};
